module.exports = __webpack_public_path__ + "img/slide-instant-order-mobile.980cde50.png";